const RUBRICA_ANALISE_AUTOMATICA_STATUS = {
  OPCIONAL: 'OPCIONAL',
  SEM_DIVERGENCIA: 'SEM_DIVERGENCIA',
  DIVERGENTE: 'DIVERGENTE',
  INVALIDO: 'INVALIDO',
  EXCECAO: 'EXCECAO',
  DUPLICADO: 'DUPLICADO',
  EXPIRADO: 'EXPIRADO',
  INATIVO: 'INATIVO',
};

export function getName(status) {
  switch (status) {
    case RUBRICA_ANALISE_AUTOMATICA_STATUS.OPCIONAL:
      return 'Opcional';
    case RUBRICA_ANALISE_AUTOMATICA_STATUS.SEM_DIVERGENCIA:
      return 'Sem divergência';
    case RUBRICA_ANALISE_AUTOMATICA_STATUS.DIVERGENTE:
      return 'Divergente';
    case RUBRICA_ANALISE_AUTOMATICA_STATUS.INVALIDO:
      return 'Inválido';
    case RUBRICA_ANALISE_AUTOMATICA_STATUS.EXCECAO:
      return 'Exceção';
    case RUBRICA_ANALISE_AUTOMATICA_STATUS.DUPLICADO:
      return 'Duplicado';
    case RUBRICA_ANALISE_AUTOMATICA_STATUS.EXPIRADO:
      return 'Expirado';
    case RUBRICA_ANALISE_AUTOMATICA_STATUS.INATIVO:
      return 'Inativo';
  }
}

export default RUBRICA_ANALISE_AUTOMATICA_STATUS;
